/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GarageSpotAttributeDefinitionDtoFromJSON, GarageSpotAttributeDefinitionDtoToJSON, } from './';
export function GarageSpotAttributeDefinitionDtoListGenericApiResponseFromJSON(json) {
    return GarageSpotAttributeDefinitionDtoListGenericApiResponseFromJSONTyped(json, false);
}
export function GarageSpotAttributeDefinitionDtoListGenericApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : json['content'].map(GarageSpotAttributeDefinitionDtoFromJSON)),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}
export function GarageSpotAttributeDefinitionDtoListGenericApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': value.content === undefined ? undefined : (value.content === null ? null : value.content.map(GarageSpotAttributeDefinitionDtoToJSON)),
        'errors': value.errors,
    };
}
